export default "/assets/images/wcf-v1.4621a3c8350b3966.png";